import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_getTopNavigationLink, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_getTopNavigationLink';

export type TransactionItemType = Response200Type extends Array<infer Model> ? Model : never;

interface TopNavigationLinkType {
    id: number
}

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export const getHeaderNavigationLink = {
    browser: {
        params: (params: TopNavigationLinkType): ParamsFetchType<TopNavigationLinkType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/get-header-link',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/get-header-link',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<TopNavigationLinkType>): Promise<GenerateUrlApiType> => {

        const resp = await openapi_website_cms_getTopNavigationLink(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            id: params.req.body.id
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body
        };
    }
};
